import React from 'react';
import { Knob } from 'primereact/knob';
import { ProgressBar } from 'primereact/progressbar';


const NivelGeral = ({ nivel, cor = 'black',width = '26px', height = '60px', numeroserie = null, onClick, fontSize, sizeIcon , label = null}) => {
    const isNull = nivel === null || nivel === undefined;
    const altura = isNull ? 0 : Math.max(0, Math.min(Number(nivel) || 0, 100));
    const isEmpty = altura === 0 && !isNull;

    const corMap = {
        preto: { nivel: '#333', fundo: '#ECEFF1' },
        ciano: { nivel: '#0D47A1', fundo: '#E1F5FE' },
        magenta: { nivel: '#C2185B', fundo: '#FCE4EC' },
        amarelo: { nivel: '#FDD835', fundo: '#FFFDE7' },
    };

    const corData = corMap[cor.toLowerCase()] || corMap['preto'];

    return (<div>
                <span style={{fontSize: '0.9rem'}}>{label}</span>                
                <ProgressBar security='warn'  value={nivel ? nivel : 0} style={{marginTop : '5px', height: '18px', fontSize : '0.7rem'}}></ProgressBar>
                <span style={{fontSize: '0.7rem', marginTop : '5px'}}>S/N: {numeroserie}</span>
           </div>)
    
};

export default NivelGeral;
